"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var makeStyles_1 = __importDefault(require("../../../../util/makeStyles"));
exports.default = (0, makeStyles_1.default)((0, styles_1.createStyles)({
    root: {
        display: 'flex',
        alignItems: 'center',
        paddingBottom: 8,
        justifyContent: 'flex-start',
    },
    divider: { height: '16px !important' },
    dropdownRoot: {
        marginLeft: 2,
        marginRight: 4,
    },
    dropdown: {
        width: 220,
        marginTop: 8,
        marginBottom: 8,
    },
    item: {
        paddingLeft: '24px !important',
        paddingRight: '24px !important',
    },
}));
